export default __webpack_public_path__ + "c4745b7d35c7b5d2212b140964bf7174.svg";